import { getOdds } from "../../../client/odds";
import { getTipVideos } from "../../../client/tips/tips";
import { Race } from "../../../types/tipster";
import { getDate, isSameDate, YYYYMMDD } from "../../../utils/TimeCalculator";
import { SortOption } from "../../Tabs/Sorter";

export const attachOddsToRunners = async (races: Race[]) => {
  try {
    const racesWithRunnerOdds = [];
    const allRaceRunners = races
      .filter(
        (race) =>
          race.status.state === "scheduled" || race.status.state === "started"
      )
      .map((race) => race.runners)
      .flat();

    const allRunnerOdds = await getOdds(allRaceRunners);

    for (let race of races) {
      const newRunners = [];
      for (let runner of race.runners) {
        const runnerOdds = allRunnerOdds?.[0]?.find((ro) => ro.id == runner.id);
        if (!runnerOdds) {
          newRunners.push(runner);
        } else {
          newRunners.push(runnerOdds);
        }
      }
      racesWithRunnerOdds.push({ ...race, runners: newRunners });
    }

    return racesWithRunnerOdds;
  } catch (error) {
    console.log("Error fetching runner odds: ", error.message);
  }
};

// NOTE: This should be reproducable accross all pages
// This checks the route and returns the index of the appropriate tab,
// i.e. /all is usually the first tab (and is in this case) so the tab with a key of 0 is selected
type TabName = "today" | "tomorrow" | "key";

export const selectAllTipsTabIndex = (tabName?: TabName | string) => {
  if (!tabName) return 0;
  if (tabName === "today") return 0;
  if (tabName === "tomorrow") return 1;
  if (tabName === "key") return 2;
};

export const DEFAULT_SORT_OPTION: SortOption = {
  text: "By Time",
  value: "time",
};

function removeDuplicateIds(array: any[]): any[] {
  const seenIds = new Set();
  return array.filter((item) => !seenIds.has(item.id) && seenIds.add(item.id));
}

export const fetchTipVideoData = async ({
  date,
  future = false,
}: {
  date?: string;
  future?: boolean;
}) => {
  const response = await getTipVideos(future);
  const videos = response.videos.filter((v) => v?.preview_video?.signed_id);

  try {
    const tipsVids = await Promise.all(videos)
      .then((res) => {
        return res.map((vid) => {
          const viewer_sources = vid?.player?.sources;
          return {
            ...vid,
            viewer_sources: viewer_sources || undefined,
            isTip: true,
          };
        });
      })
      .catch((error) => {
        console.log("TIP VID ERROR", error);
      });

    const flatTipsVids = tipsVids?.flat() || [];

    if (future) {
      const dayAfterTomorrow = YYYYMMDD(getDate(2));
      const futureVids = flatTipsVids.filter((vid) => {
        return vid.runner.race.start_time_scheduled >= dayAfterTomorrow;
      });
      return removeDuplicateIds(futureVids);
    }

    if (date) {
      const todaysTipVids = flatTipsVids.filter((vid) => {
        return isSameDate(vid.runner.race.start_time_scheduled, date);
      });
      return removeDuplicateIds(todaysTipVids);
    }

    return removeDuplicateIds(flatTipsVids);
  } catch (err) {
    console.log("Error loading tip video asset: " + err.message);
    return [];
  }
};
